import {
  retailHomepage,
  findStoreByCondition,
  queryRetailStoreThemeDetail
} from "@/api/home";
import { findClientRetailSpuByParam } from "@/api/product";
const state = {
  retailHomepage: [],
  homeProductList: {
    rows: [],
    hasNextPage: false,
    pageNo: 1,
    pageCount: 0
  },
  findStoreByCondition: {},
  queryRetailStoreThemeDetail: {
    title: "",
    details: []
  }
};

const mutations = {
  SET_RETAILHOMEPAGE(state, data) {
    state.retailHomepage = data;
  },
  SET_FINDSTOREBYCONDITION(state, data) {
    state.findStoreByCondition = data;
  },
  SET_QUERYRETAILSTORETHEMEDETAIL(state, data) {
    state.queryRetailStoreThemeDetail = data;
  },
  SET_HOMEHPRODUCTLIST(state, data) {
    if (data.pageNo === 0 || data.pageNo === 1) {
      state.homeProductList = data;
    } else {
      const data1 = state.homeProductList.rows;
      const data2 = data.rows;
      const rows = [...data1, ...data2];
      data.rows = rows;
      state.homeProductList = data;
    }
  }
};

const actions = {
  // 首页清单
  async retailHomepage({ commit }, { params }) {
    // console.log(params, "params");
    const response = await retailHomepage(params);
    // console.log("首页主题数据", response);
    if (response.code === 1) {
      commit("SET_RETAILHOMEPAGE", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 首页全部数据
  async findClientRetailSpuByParam({ commit }, { params }) {
    const response = await findClientRetailSpuByParam(params);
    // console.log("首页数据全部", response);
    if (response.code === 1) {
      commit("SET_HOMEHPRODUCTLIST", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 首页小店信息
  async findStoreByCondition({ commit }, { params }) {
    const response = await findStoreByCondition(params);
    // console.log("首页小店信息", response);
    if (response.code === 1) {
      commit("SET_FINDSTOREBYCONDITION", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  },
  // 主题清单列表信息
  async queryRetailStoreThemeDetail({ commit }, { params }) {
    const response = await queryRetailStoreThemeDetail(params);
    // console.log("主题清单列表信息", response);
    if (response.code === 1) {
      commit("SET_QUERYRETAILSTORETHEMEDETAIL", response.data);
      return Promise.resolve();
    } else return Promise.reject();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
